import { getZinePostRecordSchema } from '@common/utils/zine';
import { DatoZinePostRecord } from '@interfaces';

type Record = DatoZinePostRecord;

const getSchema = (record: Record) => {
	const { __typename } = record;

	switch (__typename) {
		case 'ZinePostRecord':
			return getZinePostRecordSchema(record);
		default:
			return undefined;
	}
};

interface JsonLdProps {
	record: Record;
}

export const JsonLd = ({ record }: JsonLdProps) => {
	const schema = getSchema(record);

	if (!schema) {
		return null;
	}

	return (
		<script
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
			type="application/ld+json"
		/>
	);
};
